/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {getInitPasswordLink, getUserByToken, login} from '../core/_requests'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'
import './custom.css'
import style from './style.module.scss'
import {Modal} from 'react-bootstrap'
import {useDispatch} from 'react-redux'
import {setUserProfileData} from '../../../common/ModalPopup/reducer'
import {useThemeMode} from '../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {useIntl} from 'react-intl'
import {useI18N} from '../../../../_metronic/i18n/Metronici18n'
import {languages} from '../../../../_metronic/partials/layout/header-menus/Languages'
import {changeLanguage} from '../../../common/utils/request'

const loginSchema = Yup.object().shape({
  Login: Yup.string()
    .min(3, 'Trois caractères minimum')
    .max(200, '200 caractères maximum')
    .required('Adresse mail obligatoire'),
  Password: Yup.string()
    .min(2, '4 caractères minimum')
    .max(32, '32 caractères maximum')
    .required('Mot de passe est obligatoire'),
})

const initialValues = {
  Login: '',
  Password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const {updateLangState, selectedLang} = useI18N()
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const {saveAuth, setCurrentUser, setAuthMessage, authMessage} = useAuth()
  const [showresetpwd, setShowresetpwd] = useState<boolean>(false)
  const [initpwd, setInitpwd] = useState<string>('')
  const [initmsg, setInitmsg] = useState<{Message: string; MessageType: string} | null>(null)
  const {mode, styles} = useThemeMode()
  const dispatch = useDispatch()
  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      // toast('Login init')
      setLoading(true)
      try {
        const {
          data: {
            data: auth,
            Status: {Message},
          },
        } = await login(values.Login, values.Password)
        if (auth) {
          saveAuth(auth)
          dispatch(setUserProfileData(auth))
          const {
            data: {
              data: user,
              Status: {Message: uMessage},
            },
          } = await getUserByToken(auth.AccessToken)

          if (user) {
            setCurrentUser(user)
            dispatch(setUserProfileData(user))
            await changeLanguage(selectedLang)
          } else if (uMessage && typeof uMessage === 'string') {
            setAuthMessage(uMessage)
            setSubmitting(false)
            setLoading(false)
          }
        } else if (Message && typeof Message === 'string') {
          setAuthMessage(Message)
          setSubmitting(false)
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('Invalid crédentials')
        setSubmitting(false)
        setLoading(false)
        dispatch(setUserProfileData(null))
      }
    },
  })

  const handleSendInitPwd = async () => {
    setInitmsg(null)
    if (initpwd && initpwd !== '') {
      const initPwdRes = await getInitPasswordLink(initpwd)
      console.log('initPwdRes : ', initPwdRes)
      if (initPwdRes && initPwdRes?.data?.Status?.Message) {
        setInitmsg({
          Message: initPwdRes?.data?.Status?.Message,
          MessageType: initPwdRes?.data?.Status?.MessageType,
        })
      }
    }
  }

  const langToUse = languages?.find((l) => {
    if (l?.lang === selectedLang) {
      return 1
    }
    return 0
  })

  return (
    <>
      <div
        data-bs-theme={mode}
        className={'d-flex h-100 overflow-hidden' + (mode === 'dark' ? ' bg-light ' : 'bg-white')}
      >
        <div
          data-bs-theme={mode}
          className={clsx('row ' + (mode === 'dark' ? ' bg-light ' : 'bg-white'), {
            [style.container]: true,
          })}
        >
          <div
            className={clsx(
              'align-items-center col-md-12 col-xl-6 ' +
                (mode === 'dark' ? ' bg-light ' : 'bg-white'),
              {[style.containerLeft]: true}
            )}
            data-bs-theme={mode}
          >
            <div className='text-center mb-20 '>
              <img
                src={toAbsoluteUrl('/media/images/Logo-Dark.png')}
                className='w-50 theme-light-show'
              />
              <img
                src={toAbsoluteUrl('/media/images/Logo-dark2.png')}
                className='w-50 theme-dark-show'
              />
            </div>
            <div className='w-100 d-flex justify-content-center'>
              <form
                className={clsx('w-100', {[style.form]: true})}
                onSubmit={formik.handleSubmit}
                noValidate
                id='kt_login_signin_form'
              >
                {/* <div className='d-flex justify-content-md-end justify-content-center mb-15 fs-3'>
                  <text className='me-5 fw-bold'>Pas encore membre ? </text>
                  <text className={clsx('fw-bold', {[style.colortext]: true})}>S'inscrire</text>
                </div> */}
                <h1 className='fw-bolder fs-3x mb-2'>{intl.formatMessage({id: 'CONFIGLIFT'})}</h1>
                <div className='text-gray-500 fw-400 fs-4 mb-20'>
                  {intl.formatMessage({id: 'MOTIV_FACIL'})}
                </div>

                <div className='text-danger pb-4'>{authMessage}</div>
                {/* begin::Form group */}
                <div className='fv-row mb-10'>
                  <input
                    placeholder={intl.formatMessage({id: 'ID_ID'})}
                    {...formik.getFieldProps('Login')}
                    className={clsx(
                      'form-control form-control-solid',
                      {'is-invalid': formik.touched.Login && formik.errors.Login},
                      {
                        'is-valid': formik.touched.Login && !formik.errors.Login,
                      }
                    )}
                    // type='email'
                    name='Login'
                    autoComplete='off'
                  />
                  {formik.touched.Login && formik.errors.Login && (
                    <div className='form-control form-control-solid'>
                      <span role='alert'>{formik.errors.Login}</span>
                    </div>
                  )}
                </div>
                {/* end::Form group */}

                {/* begin::Form group */}
                <div className='fv-row mb-10'>
                  <input
                    type='password'
                    placeholder={intl.formatMessage({id: 'PASSWORD'})}
                    autoComplete='off'
                    {...formik.getFieldProps('Password')}
                    className={clsx(
                      'form-control form-control-solid',
                      {
                        'is-invalid': formik.touched.Password && formik.errors.Password,
                      },
                      {
                        'is-valid': formik.touched.Password && !formik.errors.Password,
                      }
                    )}
                  />
                  {formik.touched.Password && formik.errors.Password && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>
                        <span role='alert'>{formik.errors.Password}</span>
                      </div>
                    </div>
                  )}
                </div>
                {/* end::Form group */}
                <div className='d-flex justify-content-end mb-10 '>
                  <span
                    className={clsx('fs-3 fw-bold cursor-pointer', {
                      [style.colortext]: mode !== 'dark',
                      [style.colortextdark]: mode === 'dark',
                    })}
                    onClick={() => {
                      setShowresetpwd(true)
                      setInitpwd('')
                    }}
                  >
                    {intl.formatMessage({id: 'LOST_PASSWORD'})}
                  </span>
                </div>

                {/* begin::Action */}
                <div className='d-flex justify-content-end'>
                  <button
                    type='submit'
                    id='kt_sign_in_submit'
                    className={clsx('btn mb-20', {
                      [style.bouton]: mode !== 'dark',
                      [style.boutonDark]: mode === 'dark',
                    })}
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    {!loading && (
                      <span className='indicator-label'>
                        {intl.formatMessage({id: 'AUTHENTICATE'})}
                      </span>
                    )}
                    {loading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        {intl.formatMessage({id: 'WAIT_PLEASE'})}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
                <div className='dropdown'>
                  <a
                    className='btn dropdown-toggle fs-6'
                    href='#'
                    role='button'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <img
                      src={toAbsoluteUrl(langToUse?.flag || '')}
                      className='h-25px w-25px vertical-align-middle mr-5px me-5'
                    />
                    {langToUse?.name}
                  </a>

                  <ul className='dropdown-menu'>
                    <li
                      onClick={async () => {
                        updateLangState('fr')
                        // await changeLanguage('fr')
                      }}
                    >
                      <span className='dropdown-item'>Français</span>
                    </li>
                    <li
                      onClick={() => {
                        updateLangState('en')
                        // await changeLanguage('en')
                      }}
                    >
                      <span className='dropdown-item'>Anglais</span>
                    </li>
                  </ul>
                </div>
                {/* end::Action */}
              </form>
            </div>
          </div>
          <div
            data-bs-theme={mode}
            className={clsx(' col-md-6 ' + (mode === 'dark' ? ' bg-dark ' : ' bg-white '), {
              [style.containerRight]: true,
            })}
          >
            <div
              className={clsx(
                {[style.triangle]: true},
                +(mode === 'dark' ? ' bg-dark ' : ' bg-white ')
              )}
            ></div>

            <img
              src={toAbsoluteUrl('/media/images/Bg-Login.png')}
              alt='Logo5'
              className={clsx({[style.bgLogin]: true})}
            />
          </div>
        </div>
      </div>
      <Modal show={showresetpwd}>
        <div className={'d-flex align-items-center justify-content-center '} data-bs-theme={mode}>
          <div
            className={
              'p-5 rounded position-relative w-100 ' + (mode === 'dark' ? 'bg-light' : 'bg-white')
            }
            data-bs-theme={mode}
          >
            <div className='d-flex justify-content-end w-100'>
              <div
                className='p-1 cursor-pointer '
                onClick={() => {
                  setShowresetpwd(false)
                  setInitpwd('')
                  setInitmsg(null)
                }}
              >
                <i className='fa fa-close text-danger' style={{fontSize: 24}}></i>
              </div>
            </div>
            <div>
              <h4>{intl.formatMessage({id: 'YOU_ID_MAIL'})}</h4>
              <input
                placeholder='test_link '
                className='form-control form-control-solid'
                onChange={(e) => {
                  setInitpwd(e?.target?.value)
                }}
              />
            </div>
            {initmsg && (
              <div>
                <div>
                  <span>{initmsg.Message}</span>
                </div>
                <div className='d-flex align-items-center justify-content-center'>
                  {initmsg && initmsg?.MessageType === 'Success' && (
                    <div
                      style={{
                        border: '2px solid #50cd89',
                        borderRadius: 100,
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i className='fa fa-check text-success' style={{fontSize: 24}}></i>
                    </div>
                  )}
                  {initmsg && initmsg?.MessageType === 'Error' && (
                    <div
                      style={{
                        border: '2px solid #e74c3c',
                        borderRadius: 100,
                        width: 32,
                        height: 32,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <i
                        className='fa fa-exclamation '
                        style={{fontSize: 24, color: styles.backgroundColor}}
                      ></i>
                    </div>
                  )}
                </div>
              </div>
            )}
            <div className='d-flex align-items-center justify-content-center py-2 pt-5'>
              <button
                type='button'
                id='kt_sign_in_submit'
                className={clsx('btn mb-0', {
                  [style.bouton]: mode !== 'light',
                  [style.boutonDark]: mode === 'dark',
                })}
                // disabled={formik.isSubmitting || !formik.isValid}
                onClick={handleSendInitPwd}
              >
                <span className='indicator-label'>
                  {initmsg?.MessageType
                    ? intl.formatMessage({id: 'RESEND'})
                    : intl.formatMessage({id: 'SEND'})}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}
